"use client";
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AboutHeroSection from "@/components/AboutHeroSection";
import Image from "next/image";
import frontend from "../../public/assets/images/services/frontend/frontend.png";
import {
  frontendTimeLine,
  services,
  technologies,
} from "../../utils/libs/utils";
const ServiceBox = ({ title, description, points }) => (
  <div className="service-inner-box w-100">
    <h3>{title}</h3>
    <p>{description}</p>
    <ul>
      {points.map((point, index) => (
        <li key={index}>{point}</li>
      ))}
    </ul>
  </div>
);

const Frontend = () => {
  useEffect(() => {
    const reveal = () => {
      document.querySelectorAll(".reveal").forEach((el) => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;
        const elementVisible = 10;

        if (
          elementTop < windowHeight - elementVisible &&
          !el.classList.contains("active")
        ) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal(); // run on load

    return () => window.removeEventListener("scroll", reveal);
  }, []);

  return (
    <div>
      <AboutHeroSection
        pillText="~ Our Tech Stack ~"
        title="Frontend Development Services with"
        highlight="Neoverce"
        description="Frontend technologies are the cornerstone of user-facing applications, bridging functionality with intuitive design. At Neoverce IT, we combine aesthetic design with cutting-edge development to deliver applications that are visually stunning and functionally robust. From responsive designs to dynamic user interactions, we ensure every element is optimized for success."
        imageAlt="Frontend Development Services"
        image={frontend}
      />
      <div className="py-5">
        <Container>
          <Row className="justify-content-center gy-4">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Tailored and Scalable <span>Frontend Development Services</span>
              </h3>
              <p className="reveal fade-bottom">
                With a focus on innovation and precision, our frontend
                technologies transform your digital vision into dynamic,
                user-friendly solutions. From responsive layouts to seamless
                interactivity, we offer a range of specialized services designed
                to meet the unique needs of businesses across industries.
              </p>
            </Col>

            {services.map((service, idx) => (
              <Col
                md={6}
                sm={12}
                key={idx}
                className="d-flex reveal fade-bottom"
              >
                <ServiceBox {...service} />
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="service-section-bg my-5">
        <Container>
          <Row className="gy-4 justify-content-center">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Advanced Technologies Used <span>in Front-end Development</span>
              </h3>
              <p className="reveal fade-bottom">
                At Neoverce, we stay ahead by utilizing the latest technologies
                to build cutting-edge, high-performing web and mobile
                applications. Our continuously updated frontend technology stack
                ensures that your projects are built with the most efficient and
                modern solutions. Here are some of the latest technologies we
                use to provide exceptional frontend development services.
              </p>
            </Col>

            {technologies.map((tech, index) => (
              <Col
                key={index}
                lg={2}
                md={3}
                sm={4}
                xs={6}
                className="reveal fade-bottom d-flex"
              >
                <div className="tech-image-box text-center">
                  <Image
                    height={100}
                    width={100}
                    alt={tech.alt}
                    src={tech.src}
                    className="img-fluid"
                  />
                  <h3>{tech.name}</h3>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="mt-5 py-5">
        <Container>
          <Row>
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Our Proven Front-end <span>Development Process</span>
              </h3>
              <p className="reveal fade-bottom">
                Our frontend development process is thoughtfully designed to
                deliver high-quality, scalable solutions that enhance user
                experience and ensure optimal performance for every project.
                Through in-depth research and collaboration, we align our
                approach with your vision to achieve the best possible outcomes.
              </p>
            </Col>
          </Row>
          <div className="py-5">
            <Row className="timeline zipzap gx-0 position-relative">
              {frontendTimeLine.map((step, i) => {
                const isFirst = i === 0;
                const isLast = i === frontendTimeLine.length - 1;

                const timelineRowClass =
                  `timeline-row d-flex align-items-center pb-5 position-relative 
            ${isFirst ? "first-timeline" : ""}
            ${isLast ? "last-timeline" : ""}
          `.trim();

                return (
                  <Col key={i} md={12} className={timelineRowClass}>
                    {i % 2 === 0 ? (
                      <>
                        <Col
                          md={6}
                          className="d-flex justify-content-center even-section align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="timeline-box text-box ms-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col md={6} className="text-md-end">
                          <div className="timeline-box text-box me-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                        <Col
                          md={6}
                          className="d-flex justify-content-center align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                      </>
                    )}
                  </Col>
                );
              })}
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Frontend;
